import { useState, useContext, useRef } from "react";
import { AppContext } from "../../Context";

const Form = () => {
  const { insertDto, lookup, getItemlookup } = useContext(AppContext);
  const [newDto, setNewDto] = useState({});
  const nomeInput = useRef(null);

  // Storing the Insert User Form Data.
  const addNewDto = (e, field) => {
    let responsavel = getItemlookup(newDto.idresponsavel);
    setNewDto({
      ...newDto,
      [field]: e.target.value,
      responsavel: responsavel,
    });
  };

  // Inserting a new user into the Database.
  const submitDto = (e) => {
    e.preventDefault();
    insertDto(newDto);
    e.target.reset();
    //toastSuccess('Tarefa inserida com sucesso!');
  };

  return (
    <form className="insertForm" onSubmit={submitDto}>
      <div className="row">
        <h4>Cadastro</h4>
      </div>
      <div className="row">
        <div className="input-field col s6">
          <input
            type="text"
            id="_name"
            name="_name"
            onChange={(e) => addNewDto(e, "nome")}
            autoComplete="off"
            required
            ref={nomeInput}
          />
          <label htmlFor="_name">Nome da tarefa</label>
        </div>

        <div className="input-field col s6">
          <select id="_responsavel" className="browser-default"
            onChange={(e) => addNewDto(e, "idresponsavel")}
            required
            defaultValue={-1}
          >
            <option key={-1} value="-1" disabled selected>Selecione um responsável</option>
            {lookup.map((lkp) => {
              return <option key={lkp.idusuario} value={lkp.idusuario}>{lkp.nome}</option>
            })}
          </select>                    
        </div>
      </div>

      <div className="row">
        <div className="input-field col s6">
            <input
              type="date"
              id="_estimativa"
              name="_estimativa"
              onChange={(e) => addNewDto(e, "estimativa")}
              autoComplete="off"
              required
            />
            <label htmlFor="_estimativa">Estimativa de conclusão</label>
        </div>  

        <div className="input-field col s6">
            <input
              type="number"
              id="_pconcluido"
              name="_pconcluido"
              onChange={(e) => addNewDto(e, "pconcluido")}
              autoComplete="off"
              defaultValue={0}
              required
            />
            <label htmlFor="_pconcluido">% executado</label>
        </div> 
      </div>

      <input type="submit" value="Inserir" />
    </form>
  );
};

export default Form;